import React, { useEffect, useState } from 'react';
import { ListItem } from '../atoms/listitem';
import ListAltTwoToneIcon from '@material-ui/icons/ListAltTwoTone';
import DownloadIcon from '@material-ui/icons/GetApp';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import variables from '../atoms/variables.json';
import { TextInput } from './../atoms/textinput';
import { CardBox } from '../atoms/card';
import { Button } from '../atoms/button';
import ContactCard from '../atoms/contactCard';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import PersonIcon from '@material-ui/icons/Person';
import { useDispatch, useSelector } from 'react-redux';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import { GetFilename } from 'components/tenantOnboarding/helpers';
import TextField from '@material-ui/core/TextField';
import ToolTip from '../atoms/ToolTip';
// import ID_ICON from './../../../assets/svgIcons/OpenFlo/ID&Reference.svg';
// import { saveAs } from 'file-saver';

import {
  CardWrapper,
  TlyfeSelector,
  TlyfeButtonWrapper,
  LineSeperator,
  Heading,
  SubHeading,
  RowContainer,
  CardFooter,
  ProfilesList,
} from './style';
// import { tenantActions, alertActions } from '_actions';
// import { generalService, TenantService } from '_services';
import BackComponent from '../atoms/backComponent';
import BottomButton from '../atoms/bottomButton';
import OpenFlowModal from '../atoms/modal';
import { SpecialCondition } from '../molecules/specialCondition';
import moment from 'moment';
import { DocumentWithStatusCard } from '../atoms/documentWithStatusCard';
import Container from '../atoms/Container/Container';
import { GetFilename } from '../helpers';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import getPlatformType from '../../../../helpers/helpers';
const layoutType = getPlatformType();
const TenancyInfoAndAgreement = (props) => {
  let landlordModal = {
    name: '',
    correspondece_address: '',
    post_code: '',
    email: '',
    number: '',
    is_england_address: true,
    number_england: '',
    correspondece_address_england: '',
    post_code_england: '',
    email_england: '',
    showForm: false,
  };
  const dispatch = useDispatch();
  const tenancyInfo = useSelector((state) => state.tenant?.tenancyInfo);

  const [addedUsers, setAddedUsers] = React.useState(tenancyInfo?.tenants);
  const [signstatus, setSignStatus] = React.useState([]);
  const [landlords, setLandlords] = React.useState([]);
  const [guarantors, setGuarantors] = React.useState([]);
  const [showCCModal, setShowCCModal] = React.useState(false);

  const [fieldsValue, setFieldValues] = useState(landlordModal);
  const [generate, setGenerate] = useState('');
  const [sendContract, setSendContract] = useState('');
  const [signModal, setSignModal] = useState(false);
  const [commonCondition, setCommonCondition] = useState([]);
  const [commonConditionText, setCommonConditionText] = useState('');
  const [number_of_occupants, setNumber_of_occupants] = useState(0);
  const [additionalError, setAdditionalError] = React.useState(false);
  const [numberOfSubTenantsWithContractEmail, setNumberOfSubTenantsWithContractEmail] = useState(0);
  const [additionalCondition, setAdditionalCondition] = useState([]);
  const [additionalConditionText, setAdditionalConditionText] = useState('');
  const [break_clause, setBreakClause] = useState('null');
  const [flowId, setFlowId] = React.useState(null);
  const [closePopup, setClosePopup] = React.useState(false);
  const idendityData = useSelector((state) => state?.tenant?.idendityData);
  const [tenants, setTenants] = React.useState([]);
  const [agreementDoc, setDoc] = React.useState('auto');
  const [bespokeContract, setBespoke] = React.useState([]);
  const [showSuccessModal, setSuccessModal] = React.useState(false);
  const modalGlobalObject = useSelector((state) => state?.tenant?.idendityData);
  const [modalState, setModalState] = React.useState({
    send_to_tenant: true,
  });
  useEffect(() => {
    if (modalGlobalObject) {
      setModalState({
        send_to_tenant: modalGlobalObject.send_to_tenant,
      });
    }
  }, [modalGlobalObject]);

  useEffect(() => {
    if (props?.match?.params?.id) {
      setFlowId(props?.match?.params?.id);
      // dispatch(tenantActions.getIdentityData(props?.match?.params?.id));
      // dispatch(tenantActions.getDocuments(props?.match?.params?.id));
    }
  }, [props?.match?.params?.id]);

  useEffect(() => {
    if (idendityData?.tenants && idendityData?.tenants?.length) {
      setTenants(idendityData?.tenants);
    } else {
      setTenants([]);
    }
  }, [idendityData?.tenants]);

  useEffect(() => {
    if (props?.match?.params?.id) {
      setFlowId(props?.match?.params?.id);
      // dispatch(tenantActions.getTenancyInfo(props?.match?.params?.id));
    }
  }, [props?.match?.params?.id]);
  useEffect(() => {
    if (numberOfSubTenantsWithContractEmail) {
      setSendContract('emailContract');
    }
  }, [numberOfSubTenantsWithContractEmail]);

  console.log('signstatus', signstatus);
  useEffect(() => {
    if (tenancyInfo?.tenants && tenancyInfo?.tenants.length) {
      setAddedUsers(tenancyInfo?.tenants);
      setNumberOfSubTenantsWithContractEmail(
        tenancyInfo?.tenants.filter((tenant) => tenant.is_contract_emailed).length
      );
    }

    if (tenancyInfo?.flow && tenancyInfo?.flow.number_of_occupants) {
      setNumber_of_occupants(tenancyInfo?.flow.number_of_occupants);
    }
    if (tenancyInfo?.flow && tenancyInfo?.flow?.break_clause) {
      setBreakClause(tenancyInfo?.flow?.break_clause);
    }
    if (tenancyInfo?.landlords && tenancyInfo?.landlords?.length) {
      setLandlords(tenancyInfo?.landlords);
    } else {
      setLandlords([]);
    }

    if (tenancyInfo?.guarantors && tenancyInfo?.guarantors?.length) {
      setGuarantors(tenancyInfo?.guarantors);
    } else {
      setGuarantors([]);
    }

    if (tenancyInfo?.flow && tenancyInfo?.flow?.common_conditions) {
      setCommonCondition(tenancyInfo?.flow?.common_conditions);
    }
    if (tenancyInfo?.flow && tenancyInfo?.flow?.additional_conditions) {
      setAdditionalCondition(tenancyInfo?.flow?.additional_conditions.split(','));
    }
    if (tenancyInfo?.flow?.bespoke_contract_url) {
      setDoc('bespoke');
      setBespoke(JSON.parse(tenancyInfo?.flow?.bespoke_contract_url));
    }
    if (tenancyInfo?.flow?.envid) {
      setSendContract('digitalContract');
      // dispatch(
      //   tenantActions.getSignedObj(props?.match?.params?.id, (data) => {
      //     console.log('datatta', data);
      //     setSignStatus(data);
      //   })
      // );
    } else {
      setSendContract('');
    }
  }, [
    tenancyInfo?.flow,
    tenancyInfo?.tenants,
    tenancyInfo?.flow?.common_conditions,
    tenancyInfo?.landlords,
    tenancyInfo?.guarantors,
    tenancyInfo?.agrementType,
    tenancyInfo?.flow?.bespoke_contract_url,
    tenancyInfo?.flow?.envid,
  ]);

  function downloadSignedContractW(id) {
    // generalService
    //   .downloadSignedContract(id)
    //   .then((response) => {
    //     if (!response.ok) {
    //       // alertActions.error('This user does not have verified Documents to download');
    //       var err = new Error('HTTP status code: ' + response.status);
    //       err.response = response;
    //       err.status = response.status;
    //       throw err;
    //     } else {
    //       return response.blob();
    //     }
    //   })
    //   .then((blob) => {
    //     // alertActions.success('Your document are being downloaded, check your download folder');
    //     // saveAs(blob, 'signedAST' + id + '.zip');
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }

  const handleChange = (e, name) => {
    setFieldValues({ ...fieldsValue, [e.target.name]: e.target.value });
  };

  const _emailContract = (data) => {
    if (tenancyInfo?.flow?.nha_contract_url || tenancyInfo?.flow?.ast_contract_url) {
      // dispatch(tenantActions.emailContract(flowId, data));
    } else {
      // dispatch(alertActions.error('Please generate the contract first'));
    }
  };

  const _createContract = () => {
    let data = {
      flow: {
        ...tenancyInfo?.flow,
        number_of_occupants: number_of_occupants,
        break_clause: break_clause,
        additional_conditions: additionalCondition.join(','),
        common_conditions: commonCondition,
      },
      landlords: landlords,
    };

    if (generate == 'nha') {
      // dispatch(tenantActions.getNHA(data, flowId));
    } else if (generate == 'ast') {
      // dispatch(tenantActions.getAST(data, flowId));
    } else {
      // dispatch(alertActions.error('Please select the contract to generate'));
    }
  };

  const _onSave = () => {
    let data = {
      landlords: landlords,
      tenants: tenants,
      agrementType: agreementDoc,
    };
    dispatch(
      tenantActions.sendContractDigitally(data, flowId, (data) => {
        setSignModal(false);
      })
    );
  };

  const _addCommonCondition = (obj) => {
    if (obj) {
      let _array = [...commonCondition];
      setCommonCondition([..._array, obj]);
    }
  };

  const _subCommonCondition = (value) => {
    let _array = [...commonCondition];
    const finalArray = _array.filter((val) => {
      if (val !== value) return val;
    });
    setCommonCondition(finalArray);
  };

  const _subAdditionCondition = (value) => {
    let _array = [...additionalCondition];
    const finalArray = _array.filter((val) => {
      if (val !== value) return val;
    });
    setAdditionalCondition(finalArray);
  };

  const _addAdditionCondition = (text) => {
    if (text) {
      let _array = [...additionalCondition];
      setAdditionalCondition([..._array, text]);
      setAdditionalConditionText('');
    } else {
      setAdditionalError(true);
    }
  };

  const DocumentBox = (title, desc, date, view, download, docList, deleteAction) => (
    <CardBox hasShadow hasBorderRadius style={{ marginTop: 20 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <SubHeading>{title}</SubHeading>
        <SubHeading style={{ color: '#9F78FF', fontSize: 12 }}>{date}</SubHeading>
        <div style={{ display: 'flex', fontSize: 12, alignItems: 'center' }}></div>
      </div>
      <SubHeading>{desc}</SubHeading>
      {docList &&
        docList.map((item, index) => (
          <div style={{ width: '70%', marginTop: '15px' }} key={'docList' + index}>
            <CardBox
              style={{
                backgroundColor: variables.peachgreen,
                border: '1px solid ' + variables.puregreen,
              }}
              hasShadow={true}
              hasBorderRadius={true}
            >
              <div style={{ justifyContent: 'space-between', display: 'flex' }}>
                <p style={{ marginTop: '5px', fontSize: '14px' }}>{item.name || 'File'}</p>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <a
                    target="_blank"
                    href={
                      item.path ||
                      'https://scholarshipfellow.com/wp-content/uploads/2021/02/illustration-document-icon.jpg'
                    }
                  >
                    <SubHeading
                      style={{
                        marginTop: '5px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: variables.purple1,
                      }}
                    >
                      View
                    </SubHeading>
                  </a>
                  <div
                    onClick={() =>
                      deleteAction(tenancyInfo?.flow?.openflow_id, false).then((data) => {
                        // dispatch(tenantActions.getTenancyInfo(tenancyInfo?.flow?.openflow_id));
                      })
                    }
                  >
                    <SubHeading
                      type="button"
                      style={{
                        marginTop: '5px',
                        fontSize: '14px',
                        fontWeight: 500,
                        marginLeft: 15,
                        color: variables.orange,
                      }}
                    >
                      Remove
                    </SubHeading>
                  </div>
                  <a
                    target="_blank"
                    href={
                      item.path ||
                      'https://scholarshipfellow.com/wp-content/uploads/2021/02/illustration-document-icon.jpg'
                    }
                  >
                    <div>
                      <DownloadIcon style={{ marginLeft: 15, color: variables.lightpurple }} />
                    </div>
                  </a>
                </div>
              </div>
            </CardBox>
          </div>
        ))}
    </CardBox>
  );

  const _onAddInfo = () => {
    let data = {
      flow: {
        ...tenancyInfo?.flow,
        number_of_occupants: number_of_occupants,
        break_clause: break_clause,
        additional_conditions: additionalCondition.join(','),
        common_conditions: commonCondition,
      },
      landlords: landlords,
      agrementType: agreementDoc,
      bespokeContractDocuments: bespokeContract,
    };
    // dispatch(tenantActions.addTenancyInfo(data, flowId));
  };

  const renderModalBody = (data) => {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
        <TextInput
          title={
            <>
              <strong>Title: </strong>
            </>
          }
          disabled={true}
          type={'row'}
          wrapperstyle={{
            width: '10%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.title || ''}
        />
        <TextInput
          disabled={true}
          title={
            <>
              <strong>First Name: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '38%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.first_name || ''}
        />
        <TextInput
          title={
            <>
              <strong>Last Name: </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.last_name || ''}
        />
        <TextInput
          title={
            <>
              <strong>Email: </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.email || ''}
        />
        <TextInput
          title={
            <>
              <strong>Contact Number: </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.contact_number || ''}
        />
      </div>
    );
  };

  const getDocumentColor = () => {
    if (tenancyInfo?.rentalOffer?.is_seen_howtorent) {
      return 'green';
    }
    return '#FC4850';
  };

  const renderRemoveCardBody = (item, index) => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <RowContainer>
        <SubHeading>Do you wish to remove this ?</SubHeading>
      </RowContainer>
      <br />
      <br />
      <TlyfeButtonWrapper>
        <Button
          onClick={() => {
            let tempLandLords = [...landlords];
            tempLandLords.splice(index, 1);
            setLandlords(tempLandLords);
            setClosePopup(false);
          }}
          title={'Yes'}
          type="stripe"
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setClosePopup(false);
          }}
          title={'No'}
          type="stripe"
        />
      </TlyfeButtonWrapper>
      <br /> <br />
      <RowContainer>
        <SubHeading>Please Note</SubHeading>
        <SubHeading> Once you remove this you cannot undo this change</SubHeading>
      </RowContainer>
    </div>
  );

  const renderCommonClauses = (item, index) => (
    <div
      style={{
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <span>
        You may select these additional clauses and edit them as appropriate. {'\n'} please select a clause in the empty
        section
      </span>

      <Select
        style={{
          width: '60%',
          height: '40px',
          borderWidth: 2,
          borderRadius: 30,
          borderColor: 'pink',
          marginLeft: '20%',
          marginTop: 30,
        }}
        onChange={handleChange}
        variant="outlined"
        name="rental_frequency"
        placeholder="duration"
      >
        <MenuItem value={'week'}>Weekly</MenuItem>
        <MenuItem value={'monthly'}>Per Calender Month</MenuItem>
        <MenuItem value={'quarterly'}>Quarterly</MenuItem>
        <MenuItem value={'6 monthly'}>6 Monthly</MenuItem>
        <MenuItem value={'annually'}>Annually</MenuItem>
      </Select>
      <TextField
        InputLabelProps={{ shrink: true }}
        multiline
        variant="outlined"
        rows={4}
        placeholder="Enter text here"
        style={{ marginTop: 20, marginBottom: 20 }}
      />
      <TlyfeButtonWrapper>
        <Button onClick={() => {}} title={'Save'} type="stripe" />
      </TlyfeButtonWrapper>
    </div>
  );

  const renderModalBodyLandloard = (data) => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <TextInput
        title={
          <>
            <strong>Title: </strong>
          </>
        }
        disabled={true}
        type={'row'}
        wrapperstyle={{
          width: '10%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data?.title || ''}
      />
      <TextInput
        title={
          <>
            <strong>First Name: </strong>
          </>
        }
        type={'row'}
        disabled={true}
        wrapperstyle={{
          width: '19%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.first_name || ''}
      />
      <TextInput
        title={
          <>
            <strong>Last Name: </strong>
          </>
        }
        type={'row'}
        disabled={true}
        wrapperstyle={{
          width: '19%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.last_name || ''}
      />
      <TextInput
        title={
          <>
            <strong>Email: </strong>
          </>
        }
        type={'row'}
        disabled={true}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.email || ''}
      />
      <TextInput
        title={
          <>
            <strong>Contact Number: </strong>
          </>
        }
        type={'row'}
        disabled={true}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.number || ''}
      />
      <TextInput
        title={
          <>
            <strong>Post Code: </strong>
          </>
        }
        type={'row'}
        disabled={true}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.post_code || ''}
      />
      <TextInput
        title={
          <>
            <strong>Correspondence Address: </strong>
          </>
        }
        type={'row'}
        disabled={true}
        wrapperstyle={{
          width: '100%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.correspondece_address || ''}
      />
    </div>
  );

  const renderModalBodyGuarantor = (data) => {
    return (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <TextInput
          title={
            <>
              <strong>Title: </strong>
            </>
          }
          disabled={true}
          type={'row'}
          wrapperstyle={{
            width: '48%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data.title || ''}
        />
        <TextInput
          title={
            <>
              <strong>First Name: </strong>
            </>
          }
          disabled={true}
          type={'row'}
          wrapperstyle={{
            width: '24%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data.first_name || ''}
        />
        <TextInput
          title={
            <>
              <strong>Last Name: </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '24%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data.last_name || ''}
        />
        <TextInput
          title={
            <>
              <strong>Correspondence Address: </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '48%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data.correspondece_address || ''}
        />
        <TextInput
          title={
            <>
              <strong>Post Code : </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '48%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data.post_code || ''}
        />
        <TextInput
          title={
            <>
              <strong>Email Address : </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '48%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data.email || ''}
        />
        <TextInput
          title={
            <>
              <strong>Contact Number : </strong>
            </>
          }
          type={'row'}
          disabled={true}
          wrapperstyle={{
            width: '48%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data.number || ''}
        />
      </div>
    );
  };

  const handleReferencingSelection = (send_digital_contract, index, isGarunter, isLandLords) => {
    let teampArr = [...tenants];
    if (isLandLords) {
      teampArr = [...landlords];
    }
    if (isGarunter) {
      if (teampArr[index].gaurantor) {
        teampArr[index].gaurantor = {
          ...teampArr[index].gaurantor,
          send_digital_contract,
        };
      } else {
        teampArr[index].gaurantor = {
          send_digital_contract,
        };
      }
    } else {
      teampArr[index].send_digital_contract = send_digital_contract;
    }

    if (isLandLords) {
      setLandlords(teampArr);
    } else {
      setTenants(teampArr);
    }
  };

  const renderReferencingModal = () => (
    <div>
      <SubHeading>Below are a list of people who are stakeholders in this agreement</SubHeading>
      <SubHeading>Please select the people who are required to sign this agreement</SubHeading>
      <Heading>Tenants</Heading>
      <ProfilesList style={{ marginTop: 0 }}>
        {tenants &&
          tenants.map((item, index) => {
            console.log('itemitemitem,itemitemitem', item);
            return (
              <ContactCard
                style={{ marginTop: 0 }}
                key={item.email + new Date()}
                nonRemove
                key={item.opbrix_id}
                row={item.email}
                is_lead={item.is_lead ? true : false}
                name={item.first_name + ' ' + item.last_name}
                renderModal={renderModalBody(item)}
                selection={true}
                isSelected={item?.send_digital_contract}
                onSelect={(data) => handleReferencingSelection(data, index, false)}
              />
            );
          })}
      </ProfilesList>
      <Heading style={{ marginTop: 15 }}>Guarantors</Heading>
      <ProfilesList style={{ marginTop: 0 }}>
        {tenants &&
          tenants.map((item, index) => {
            if (item?.gaurantor?.first_name) {
              return (
                <ContactCard
                  key={item.email + new Date()}
                  nonRemove
                  style={{ marginTop: 0 }}
                  key={item.opbrix_id}
                  heading={'Guarantor Details'}
                  row={item.email}
                  is_lead={false}
                  name={item?.gaurantor?.first_name + ' ' + item?.gaurantor?.last_name}
                  renderModal={renderModalBodyGuarantor(item)}
                  selection={true}
                  isSelected={item?.gaurantor?.send_digital_contract}
                  onSelect={(data) => handleReferencingSelection(data, index, true)}
                />
              );
            } else {
              return null;
            }
          })}
      </ProfilesList>
      <Heading style={{ marginTop: 15 }}>Landlords</Heading>
      <ProfilesList style={{ marginTop: 0 }}>
        {landlords &&
          landlords.map((item, index) => (
            <ContactCard
              style={{ marginTop: 0 }}
              key={item.email + new Date()}
              nonRemove
              heading={'Landlord Details'}
              key={item.opbrix_id}
              row={item.email}
              is_lead={item.is_lead ? true : false}
              name={item.first_name + ' ' + item.last_name}
              renderModal={renderModalBodyLandloard(item)}
              selection={true}
              isSelected={item?.send_digital_contract}
              onSelect={(data) => handleReferencingSelection(data, index, false, true)}
            />
          ))}
      </ProfilesList>
      <SubHeading style={{ marginTop: 20 }}>Are you happy to proceed</SubHeading>
      <RowContainer>
        <Button type="stripe" onClick={() => _onSave()} title="Yes" />
        <Button type="stripe" onClick={() => setSignModal(false)} style={{ marginLeft: 15 }} title="No" />
      </RowContainer>
      <SubHeading style={{ marginTop: 20 }}>
        <b>PLEASE NOTE:</b>
        <br />
        If you if you choose digital signitories all selected people must sign to complete the agreement.
      </SubHeading>
    </div>
  );
  const addDoc = (data, index, type) => {
    let teampArr = [...addedUsers];
    if (teampArr[index]) {
      teampArr[index]['email_tanancey_agreement'] = [
        {
          document_url: data[0],
        },
      ];
    }
    setAddedUsers(teampArr);
  };

  console.log('addedUsersaddedUsers', addedUsers);
  const removeDoc = (index, docIndex, type) => {
    let teampArr = [...addedUsers];

    let tempDocArry = teampArr[index]['email_tanancey_agreement'];

    tempDocArry.splice(docIndex, 1);

    teampArr[index]['email_tanancey_agreement'] = [...tempDocArry];

    setAddedUsers(teampArr);
  };
  return (
    <Container>
      <CardWrapper>
        <ListItem
          type={'complete'}
          title={'Tenancy Information & Agreements'}
          listIcon={<ListAltTwoToneIcon style={{ fontSize: '25px', color: variables.purple1 }} />}
          // icon={ID_ICON}
          showPropertyCard
          description={`Digitally create, check or amend your tenancy Agreement, and send it to all parties.`}
        />

        <BackComponent
          id={flowId}
          isComplete={tenancyInfo?.flow?.landlord_status === 1 ? true : false}
          flowtype={'landlord_status'}
        />

        <TlyfeSelector style={{ marginTop: 0, justifyContent: 'space-between' }}>
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Heading>Tenant(s) & Occupants</Heading>
          </div>
        </TlyfeSelector>
        <CardBox backColor={variables.powderBlue}>
          <SubHeading color={variables.scooter}>
            Fill in the information below to pre-populate the standard contracts, so they are ready to send straight to
            all parties.
          </SubHeading>
        </CardBox>

        <React.Fragment>
          <RowContainer style={{ marginBottom: 0 }}>
            {addedUsers && addedUsers.length
              ? addedUsers.map((item) => (
                  <ContactCard
                    key={item?.opbrix_id}
                    isPrimary={item?.is_lead ? true : false}
                    name={item?.first_name + ' ' + item?.last_name}
                    is_lead={item?.is_lead}
                    isLeadEditable={false}
                    renderModal={renderModalBody(item)}
                    nonRemove
                  />
                ))
              : null}
          </RowContainer>
        </React.Fragment>
        <CardBox hasShadow hasBorderRadius style={{ marginTop: 20, position: 'relative', width: '100%' }}>
          <ToolTip
            style={{ top: '0%', right: '-40%' }}
            heading={'Additional Occupants'}
            ContentData={[
              "Add any additional occupants that will form part of your household but may not necessarily be on the Tenancy Agreement (e.g. Children, Nanny's, Au Pairs).",
            ]}
          />
          <Heading>Additional Occupants</Heading>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TextInput
              title={'No of Additional Occupants'}
              type={'row'}
              wrapperstyle={{
                marginBottom: 15,
                width: '70%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              value={number_of_occupants}
              onChange={(e) => setNumber_of_occupants(e.target.value)}
              name="commonConditionText"
            />
          </div>
        </CardBox>

        <LineSeperator />
        <React.Fragment>
          <Heading>Landlord(s)</Heading>
          <RowContainer style={{ marginBottom: 40 }}>
            {landlords && landlords.length
              ? landlords.map((item, landlordIndex) => (
                  <ContactCard
                    key={item.email}
                    data={item}
                    nonRemove
                    isPrimary={item.isLeadTeanant ? true : false}
                    name={`${item.first_name} ${item.last_name}`}
                    heading={'Landlord Details'}
                    is_lead={item.is_lead}
                    renderModal={renderModalBodyLandloard(item)}
                    tooltip={item.is_lead ? 'Lead Landlord' : 'Not Lead Landlord'}
                    setClosePopup={setClosePopup}
                    closePopup={closePopup}
                    renderRemoveCardBody={renderRemoveCardBody(item, landlordIndex)}
                    onDelete={(data) => {
                      let tempLandLords = [...landlords];
                      tempLandLords.splice(landlordIndex, 1);
                      setLandlords(tempLandLords);
                    }}
                  />
                ))
              : null}
          </RowContainer>
          <LineSeperator />
        </React.Fragment>
        <React.Fragment>
          <Heading>Guarantor</Heading>
          {tenants &&
            tenants.map((data, index) => (
              <React.Fragment>
                {data?.gaurantor?.show_card ? (
                  <CardBox
                    key={data?.app_user_id}
                    style={{ marginBottom: '5%', backgroundColor: '#f7f7f7' }}
                    hasShadow={true}
                    hasBorderRadius={true}
                  >
                    {data?.gaurantor?.show_card ? (
                      <ContactCard
                        nonRemove
                        name={`${data?.gaurantor?.first_name} ${data?.gaurantor?.last_name}`}
                        renderModal={renderModalBodyGuarantor(data?.gaurantor)}
                        heading={'Guarantor Details'}
                      />
                    ) : null}
                  </CardBox>
                ) : null}
              </React.Fragment>
            ))}
          <LineSeperator />
        </React.Fragment>
        <SpecialCondition
          commonCondition={commonCondition}
          additionalCondition={additionalCondition}
          break_clause={break_clause}
          setBreakClause={setBreakClause}
          _subAdditionCondition={_subAdditionCondition}
          _subCommonCondition={_subCommonCondition}
          commonConditionText={commonConditionText}
          setCommonConditionText={setCommonConditionText}
          _addCommonCondition={_addCommonCondition}
          additionalConditionText={additionalConditionText}
          setAdditionalConditionText={setAdditionalConditionText}
          _addAdditionCondition={_addAdditionCondition}
          _subAdditionCondition={_subAdditionCondition}
        />
        <Heading style={{ marginTop: 20 }}>Tenancy Agreement Document</Heading>
        <SubHeading>
          Do you wish to auto generate a tenancy agreement form the information you have provided, or manually email
          your own bespoke tenancy agreement?
        </SubHeading>

        <RadioGroup
          aria-label="generate"
          name="generate"
          value={agreementDoc}
          style={{ flexDirection: 'row', alignSelf: 'center' }}
          onChange={(e) => setDoc(e.target.value)}
        >
          <FormControlLabel
            value="auto"
            control={
              <Radio
                style={{
                  color: variables.purple1,
                  fontSize: 10,
                  justifyContent: 'flex-end',
                }}
              />
            }
            label="Auto Generate"
          />
          <FormControlLabel
            value="bespoke"
            control={
              <Radio
                style={{
                  color: variables.purple1,
                  fontSize: 10,
                  justifyContent: 'flex-end',
                }}
              />
            }
            label="Bespoke Email Contract"
          />
        </RadioGroup>
        {agreementDoc == 'bespoke' ? (
          <>
            {bespokeContract.length > 0
              ? bespokeContract.map((e, index) => (
                  <CardBox
                    hasShadow={true}
                    hasBorderRadius={true}
                    style={{
                      backgroundColor: variables.peachgreen,
                      border: '1px solid ' + variables.puregreen,
                      marginTop: 40,
                      width: '50%',
                      alignSelf: 'center',
                    }}
                  >
                    <div style={{ justifyContent: 'space-between', display: 'flex' }}>
                      <p style={{ marginTop: '5px', fontSize: '14px' }}>Agreement {index + 1}</p>
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div
                          onClick={() => {
                            let tempArray = [...bespokeContract];
                            tempArray.splice(index, 1);

                            setBespoke(tempArray);
                          }}
                        >
                          <SubHeading
                            style={{
                              marginTop: '5px',
                              fontSize: '14px',
                              fontWeight: 500,
                              color: 'red',
                              marginRight: 20,
                            }}
                          >
                            Remove
                          </SubHeading>
                        </div>
                        <a target="_blank" href={e}>
                          <SubHeading
                            style={{
                              marginTop: '5px',
                              fontSize: '14px',
                              fontWeight: 500,
                              color: variables.purple1,
                            }}
                          >
                            View
                          </SubHeading>
                        </a>
                      </div>
                    </div>
                  </CardBox>
                ))
              : null}
            <Button
              onClick={(e) => setBespoke([...bespokeContract, e?.data])}
              type={'Upload'}
              style={{ color: variables.purple1, width: 200, alignSelf: 'center', marginTop: 40 }}
              title={'Upload Bespoke Contract'}
            />
            <>
              <CardBox hasShadow={true} hasBorderRadius={true} style={{ marginTop: 40, padding: 20 }}>
                <Heading style={{ marginTop: 40 }}>Email Bespoke Contracts</Heading>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <SubHeading> Please click send to individually email all the parties.</SubHeading>

                  <Button
                    onClick={() => {
                      if (bespokeContract.length) {
                        dispatch();
                        // tenantActions.sendBespokeContract({ bespokeContractDocuments: bespokeContract }, flowId)
                      } else {
                        // dispatch(alertActions.error('Please upload contract to proceed!'));
                      }
                    }}
                    style={{
                      borderColor: variables.puregreen,
                      color: '#000',
                    }}
                    title={'Send Bespoke Contract'}
                    type="stripe"
                  />
                </div>
                <SubHeading style={{ marginTop: 20 }}>
                  All parties will recived a email PDF that will allow them to download, sign and send back.
                </SubHeading>
                <SubHeading style={{ marginTop: 30 }}>PLEASE NOTE: No verification is required for this.</SubHeading>

                {addedUsers ? (
                  <>
                    {addedUsers.map((data, index) => {
                      return (
                        <CardBox hasShadow={true} hasBorderRadius={true} style={{ marginTop: 40, padding: 20 }}>
                          <DocumentWithStatusCard
                            flowID={flowId}
                            isPrimary={data.is_lead}
                            name={data?.first_name + ' ' + data?.last_name}
                            customButton={true}
                            isCustomTextSent={data?.is_contract_emailed}
                            docValue={data?.email_tanancey_agreement ? data?.email_tanancey_agreement : []}
                            onClick={(data) => addDoc(data, index, 'agent_uploaded_ast')}
                            onRemove={(docIndex) => removeDoc(index, docIndex, 'agent_uploaded_ast')}
                          />
                        </CardBox>
                      );
                    })}
                  </>
                ) : null}

                {addedUsers ? (
                  <>
                    {addedUsers.map((data, index) => {
                      return (
                        <>
                          {data?.uploaded_ast_contract_url ? (
                            <div>
                              <div style={{ flex: 0.95 }}>
                                <SubHeading
                                  style={{
                                    fontSize: '14px',
                                    marginTop: 10,
                                    fontWeight: 'bold',
                                    color: props.type == 'complete' ? variables.purple1 : 'black',
                                  }}
                                >
                                  {data?.first_name + data?.last_name + ' Uploaded Signed Tenancy Agreement'}
                                </SubHeading>
                                <SubHeading
                                  style={{ marginTop: '5px', fontSize: '13px' }}
                                  dangerouslySetInnerHTML={{ __html: props.description }}
                                />
                              </div>

                              <div style={{ width: '70%', marginTop: '15px' }}>
                                <CardBox
                                  hasShadow={true}
                                  hasBorderRadius={true}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    backgroundColor: variables.peachgreen,
                                    border: '1px solid ' + variables.puregreen,
                                  }}
                                >
                                  <SubHeading
                                    style={{
                                      marginTop: '5px',
                                      fontSize: '14px',
                                      width: 230,
                                      height: '100%',
                                    }}
                                  >
                                    {GetFilename(data?.uploaded_ast_contract_url)}
                                  </SubHeading>
                                  <a target="_blank" href={data?.uploaded_ast_contract_url}>
                                    <SubHeading
                                      style={{
                                        marginTop: '5px',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        color: variables.purple1,
                                      }}
                                    >
                                      View
                                    </SubHeading>
                                  </a>
                                </CardBox>
                              </div>
                            </div>
                          ) : null}
                        </>
                      );
                    })}
                  </>
                ) : null}
              </CardBox>
            </>
          </>
        ) : (
          <>
            <Heading style={{ marginTop: 20 }}>Auto Tenancy Agreement Creation</Heading>
            <CardBox
              hasShadow={true}
              hasBorderRadius={true}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 10,
                position: 'relative',
                width: '100%',
              }}
            >
              <ToolTip
                style={{ top: '0%', right: '-40%' }}
                heading={'Tool tip title'}
                ContentData={[
                  'Use an AST if the following apply:',
                  'The tenants are individuals (not a company);',
                  'The property will be the tenant’s main residence; the annual rent does not exceed £100k p/a;',
                  'The Landlord will not be a Resident Landlord.',
                ]}
              />
              <ToolTip
                style={{ bottom: '-280%', right: '-40%' }}
                heading={'Tool tip title'}
                ContentData={[
                  'Custom tenancy agreement?',
                  'If you with to autogenerate a bespoke AST, please contact support@openbrix.co.uk and we will implement a bespoke AST for your branch at a one-off fixed cost.',
                ]}
              />

              <RadioGroup
                aria-label="generate"
                name="generate"
                //value={data?.gaurantor?.selection_status}
                value={generate}
                onChange={(e) => setGenerate(e.target.value)}
              >
                <FormControlLabel
                  value="ast"
                  control={
                    <Radio
                      style={{
                        color: variables.purple1,
                        fontSize: 10,
                        justifyContent: 'flex-end',
                      }}
                    />
                  }
                  label="Assured Shorthold Tenancy (AST)"
                />
                <FormControlLabel
                  value="nha"
                  control={
                    <Radio
                      style={{
                        color: variables.purple1,
                        fontSize: 10,
                        justifyContent: 'flex-end',
                      }}
                    />
                  }
                  label="Non Housing Act (NHA)"
                />
              </RadioGroup>

              {/* <FormControl component="fieldset">
            <FormControlLabel
              control={
                <Checkbox
                  name="ast"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.ast}
                  onChange={(e) =>
                    setFieldValues({ ...fieldsValue, ast: !fieldsValue.ast ,nha:false})
                  }
                />
              }
              label="Assured Shorthold Tenancy (AST)"
              style={{ color: "#000", fontSize: 10 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="nha"
                  style={{ color: variables.heliotrope }}
                  checked={fieldsValue.nha}
                  onChange={(e) =>{
                    setFieldValues({ ...fieldsValue, nha: !fieldsValue.nha,ast:false })
                   }
                  }
                />
              }
              label="Non Housing Act (NHA)"
              style={{ color: "#000", fontSize: 10 }}
            />
          </FormControl> */}
              <Button
                textColor={'black'}
                type="custom"
                color={variables.lead_green}
                title="Create contract"
                style={{ marginLeft: 'auto', marginTop: 10 }}
                onClick={() => _createContract()}
              />
            </CardBox>
            {tenancyInfo?.flow?.is_ast_generated
              ? DocumentBox(
                  'Assured Shorthold Tenancy (AST)',
                  'An Assured Shorthold Tenancy Agreement is automatically created using the information you have already populated. ',
                  'Last updated ' + moment(tenancyInfo?.flow?.ast_generate_at).format('DD-MM-YYYY HH:mm:ss'),
                  'https://scholarshipfellow.com/wp-content/uploads/2021/02/illustration-document-icon.jpg',
                  'https://scholarshipfellow.com/wp-content/uploads/2021/02/illustration-document-icon.jpg',
                  [
                    {
                      name: 'AST.pdf',
                      path: tenancyInfo?.flow?.ast_contract_url,
                    },
                    {
                      name: 'Prescribed.pdf',
                      path: tenancyInfo?.flow?.prescribed_contract_url,
                    },
                  ]
                  // TenantService.deleteAST
                )
              : null}
            {tenancyInfo?.flow?.is_nha_generated
              ? DocumentBox(
                  'Non Housing Act (NHA)',
                  'An Non Housing Acts Agreement is automatically created using the information you have already populated.',
                  'Last updated ' + tenancyInfo?.flow?.nha_generate_at,
                  'https://scholarshipfellow.com/wp-content/uploads/2021/02/illustration-document-icon.jpg',
                  'https://scholarshipfellow.com/wp-content/uploads/2021/02/illustration-document-icon.jpg',
                  [
                    {
                      name: GetFilename(tenancyInfo?.flow?.nha_contract_url),
                      path: tenancyInfo?.flow?.nha_contract_url,
                    },
                  ]
                  // TenantService.deleteNHA
                )
              : null}

            <LineSeperator />
            <CardBox
              hasShadow={true}
              hasBorderRadius={true}
              style={{
                marginTop: 20,
                width: '100%',
              }}
            >
              <SubHeading>Please select your contract</SubHeading>
              <SubHeading>Please select the type of contract you wish to send.</SubHeading>
              <SubHeading>
                Send eSigniture contract via tlyfe All parties can digitally sign their contract via a legally binging
                eSigniture process. - Tenants will use thier tlyfe app to digitally sign. - Landlords and Gurantors will
                be emailed a link to digitally sign.
              </SubHeading>
              <SubHeading>Please note: </SubHeading>{' '}
              <SubHeading style={{ color: variables.orange }}>
                Tenants must be verified to complete the e-sign process
              </SubHeading>
              <SubHeading>Send esignture via email</SubHeading>
              <SubHeading>
                {' '}
                All parties will recived an email which they can then digitally sign using esigniture.
              </SubHeading>
              <SubHeading>Please note: No verification is required for this.</SubHeading>
              <div style={{ marginLeft: layoutType == 'phone' ? 0 : '100px', paddingTop: '30px' }}>
                <RadioGroup
                  aria-label="sendContract"
                  name="sendContract"
                  value={sendContract}
                  onChange={(e) => setSendContract(e.target.value)}
                >
                  <FormControlLabel
                    value="digitalContract"
                    control={
                      <Radio
                        style={{
                          color: variables.purple1,
                          fontSize: 10,
                          justifyContent: 'flex-end',
                        }}
                      />
                    }
                    label="Send eSigniture contract via tlyfe"
                  />
                  <FormControlLabel
                    value="emailContract"
                    control={
                      <Radio
                        style={{
                          color: variables.purple1,
                          fontSize: 10,
                          justifyContent: 'flex-end',
                        }}
                      />
                    }
                    label="Send contract via email PDF"
                  />
                </RadioGroup>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                <Button
                  type="custom"
                  textColor={'black'}
                  color={variables.lead_green}
                  title="Send contract"
                  onClick={
                    () => {}
                    // sendContract
                    //   ? sendContract == 'emailContract'
                    //     ? _emailContract()
                    //     : setSignModal(true)
                    //   : dispatch(alertActions.error('Please select any contract type'))
                  }
                />
              </div>
            </CardBox>
            {signstatus?.status ? (
              <>
                <LineSeperator />
                <CardBox hasShadow={true} hasBorderRadius={true}>
                  <SubHeading>Digitally Signed Tenancy Agreement</SubHeading>

                  {signstatus.data &&
                  signstatus.data.details &&
                  signstatus.data.details.recipients &&
                  signstatus.data.details.recipients.length
                    ? signstatus.data.details.recipients.map((item, index) => (
                        <CardBox
                          hasShadow={true}
                          hasBorderRadius={true}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '10px',
                          }}
                        >
                          <div>
                            {
                              <PersonIcon
                                style={{
                                  color: item.is_lead ? variables.lead_green : variables.heliotrope,
                                }}
                              />
                            }
                            {item?.name}
                          </div>

                          {item?.contract_sent_at && (
                            <SubHeading style={{ margin: 0, color: 'black' }}>
                              Sent on: {moment(item?.contract_sent_at).format('DD-MM-YYYY')}
                            </SubHeading>
                          )}

                          {item?.signed_at && (
                            <SubHeading style={{ margin: 0, color: 'black' }}>
                              Signed on: {moment(item?.signed_at).format('DD-MM-YYYY')}
                            </SubHeading>
                          )}
                          <Button
                            type={item?.sign_status == 'SIGNED' ? 'custom' : 'stripe'}
                            color={item?.sign_status == 'SIGNED' ? variables.lead_green : variables.heliotrope}
                            title={item?.sign_status}
                          />
                        </CardBox>
                      ))
                    : null}
                  <CardBox
                    hasShadow={true}
                    hasBorderRadius={true}
                    style={{
                      backgroundColor: variables.peachgreen,
                      border: '1px solid ' + variables.puregreen,
                      marginTop: '4%',
                    }}
                  >
                    <div style={{ justifyContent: 'space-between', display: 'flex' }}>
                      {signstatus?.data && signstatus?.data?.status == 'COMPLETE' ? (
                        <SubHeading style={{ marginTop: '5px', fontSize: '14px' }}>AST complete.pdf</SubHeading>
                      ) : (
                        <SubHeading> Waiting for all parties to sign</SubHeading>
                      )}

                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {/*<a target="_blank" href={'https://google.com'}>
                          <p
                              style={{
                                marginTop: '5px',
                                fontSize: '14px',
                                fontWeight: 500,
                                color: variables.purple1,
                              }}
                          >
                            View
                          </p>
                        </a>*/}
                      </div>
                    </div>
                  </CardBox>
                </CardBox>
                {signstatus?.data && signstatus?.data?.status == 'COMPLETE' ? (
                  <Button
                    type={'stripe'}
                    style={{ marginTop: 20, alignSelf: 'flex-end' }}
                    title="Download Signed Contracts"
                    onClick={() => downloadSignedContractW(flowId)}
                  />
                ) : null}
              </>
            ) : null}

            {addedUsers && numberOfSubTenantsWithContractEmail !== 0 ? (
              <>
                <LineSeperator />
                <CardBox style={{ marginBottom: '5%', width: '100%' }} hasShadow hasBorderRadius>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Heading>Email Contracts</Heading>
                  </div>
                  {addedUsers.map((data, index) => {
                    return (
                      <React.Fragment key={index}>
                        <RowContainer>
                          <div
                            style={{
                              flex: 1,
                              paddingRight: '10%',
                              paddingLeft: '4%',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <CardBox
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                              hasBorderRadius
                            >
                              <SubHeading style={{ margin: 0 }}>
                                <PersonIcon style={{ color: variables.lead_green }} />
                                {data?.first_name + ' ' + data?.last_name}
                              </SubHeading>

                              <SubHeading style={{ margin: 0, color: 'black' }}>
                                Sent on: {data?.ast_sent_at}
                              </SubHeading>

                              <SubHeading style={{ margin: 0 }}>
                                <Button
                                  type="stripe"
                                  color={data.is_contract_emailed ? variables.puregreen : variables.lightgrey}
                                  textColor={data.is_contract_emailed ? 'black' : 'white'}
                                  title={data.is_contract_emailed ? 'Email Sent' : 'Not Sent'}
                                  style={{
                                    marginTop: 30,
                                    marginBottom: 10,
                                    padding: 10,
                                    borderColor: '#90C418',
                                    display: 'inline',
                                  }}
                                />
                              </SubHeading>
                            </CardBox>
                          </div>
                        </RowContainer>
                      </React.Fragment>
                    );
                  })}

                  {landlords.map((data, index) => {
                    return (
                      <React.Fragment key={index}>
                        <RowContainer>
                          <div
                            style={{
                              flex: 1,
                              paddingRight: '10%',
                              paddingLeft: '4%',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <CardBox
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                              hasBorderRadius
                              backColor="#fff"
                            >
                              <SubHeading style={{ margin: 0 }}>
                                <PersonIcon style={{ color: variables.lead_green }} />
                                {data?.first_name + ' ' + data?.last_name}
                              </SubHeading>
                              <SubHeading style={{ margin: 0, color: 'black' }}>
                                Sent on: {data?.ast_sent_at}
                              </SubHeading>

                              <SubHeading style={{ margin: 0 }}>
                                <Button
                                  type="stripe"
                                  title={data.is_contract_emailed ? 'Email Sent' : 'Not Sent'}
                                  style={{
                                    marginTop: 30,
                                    marginBottom: 10,
                                    padding: 10,
                                    borderColor: '#90C418',
                                    display: 'inline',
                                  }}
                                />
                              </SubHeading>
                            </CardBox>
                          </div>
                        </RowContainer>
                      </React.Fragment>
                    );
                  })}

                  {guarantors.map((data, index) => {
                    return (
                      <React.Fragment key={index}>
                        <RowContainer>
                          <div
                            style={{
                              flex: 1,
                              paddingRight: '10%',
                              paddingLeft: '4%',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <CardBox
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                              hasBorderRadius
                              backColor="#fff"
                            >
                              <SubHeading style={{ margin: 0 }}>
                                <PersonIcon style={{ color: variables.lead_green }} />
                                {data?.first_name + ' ' + data?.last_name}
                              </SubHeading>

                              <SubHeading style={{ margin: 0, color: 'black' }}>
                                Sent on: {data?.ast_sent_at}
                              </SubHeading>

                              <SubHeading style={{ margin: 0 }}>
                                <Button
                                  type="stripe"
                                  title={data.is_contract_emailed ? 'Email Sent' : 'Not Sent'}
                                  style={{
                                    marginTop: 30,
                                    marginBottom: 10,
                                    padding: 10,
                                    borderColor: '#90C418',
                                    display: 'inline',
                                  }}
                                />
                              </SubHeading>
                            </CardBox>
                          </div>
                        </RowContainer>
                      </React.Fragment>
                    );
                  })}
                </CardBox>
              </>
            ) : null}
          </>
        )}
        <LineSeperator />
        <Heading style={{ marginTop: 0 }}>How To Rent Document</Heading>
        <CardBox hasShadow hasBorderRadius style={{ marginTop: 20, width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <SubHeading>How to Rent</SubHeading>
            <InsertDriveFileIcon style={{ color: getDocumentColor(), fontSize: '35px' }} />
          </div>
          <SubHeading>
            Who is this guide for? This guide is for people who are renting a home privately under an assured shorthold
            tenancy or direct from a landlord or through a letting agency. Most of it will equally apply if they are in
            a shared property but in certain cases, their rights and responsibilities will vary.
            <strong>Please note.</strong> This guide will be automatically sent with your tenancy agreement
          </SubHeading>
          <div style={{ width: '70%', marginTop: '15px' }}>
            <CardBox
              hasShadow={true}
              hasBorderRadius={true}
              style={{
                backgroundColor: variables.peachgreen,
                border: '1px solid ' + variables.puregreen,
              }}
            >
              <div style={{ justifyContent: 'space-between', display: 'flex', height: 25 }}>
                <SubHeading style={{ marginTop: '5px', fontSize: '14px' }}>HowtoRent.pdf</SubHeading>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <a target="_blank" href={'https://assets.openbrix.co.uk/HowToRent.pdf'}>
                    <SubHeading
                      style={{
                        marginTop: '5px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: variables.purple1,
                      }}
                    >
                      View
                    </SubHeading>
                  </a>
                </div>
              </div>
            </CardBox>
          </div>
        </CardBox>
        <CardFooter></CardFooter>

        <LineSeperator />
        <BottomButton
          showSendbutton={false}
          showContinueModal={false}
          onContinue={() => {
            _onAddInfo();
          }}
        />
      </CardWrapper>

      <OpenFlowModal
        showModal={showCCModal}
        setShowModal={setShowCCModal}
        modalBody={renderCommonClauses()}
        showFooter={false}
        modalHeading="Condition Clauses"
      />
      {signModal && (
        <OpenFlowModal
          showModal={signModal}
          setShowModal={setSignModal}
          modalBody={renderReferencingModal()}
          showFooter={false}
          modalHeading="Agreement Signitories"
          modalWidth={600}
        />
      )}
    </Container>
  );
};
export default drawerHoc({
  Component: TenancyInfoAndAgreement,
  showBackButton: true,
});
